module.exports = __webpack_public_path__ + "6a02887381b5bc891c4e6aee6ee7fa48.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/py.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/py.svg
// module chunks = 0